'use client';

import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import { useHydrateOnInteraction } from '@/hooks/useHydrateOnInteraction';

const UniversalChatProvider = dynamic(
  () => import('./UniversalChatProvider').then((mod) => mod.UniversalChatProvider),
  {
    ssr: false,
  }
);

type LazyUniversalChatProviderProperties = {
  children: ReactNode;
};

export function LazyUniversalChatProvider({ children }: LazyUniversalChatProviderProperties) {
  const { hasInteracted } = useHydrateOnInteraction();

  if (!hasInteracted) {
    return <>{children}</>;
  }

  return <UniversalChatProvider>{children}</UniversalChatProvider>;
}
